"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { getWaveDescriptionPreviewText } from "@/helpers/waves/waveDescriptionPreview";
import { useWaveById } from "@/hooks/useWaveById";
export interface PublicWaveShellData {
  readonly id: string;
  readonly name: string;
  readonly picture: string | null;
  readonly descriptionPreview: string | null;
  readonly membersCount: number;
  readonly postsCount: number;
}
export type PublicWaveShellState = {
  readonly status: "loading";
} | {
  readonly status: "unavailable";
} | {
  readonly status: "ready";
  readonly wave: PublicWaveShellData;
};
interface UsePublicWaveShellStateOptions {
  readonly enabled?: boolean;
}
function getPublicWaveShellDataFromApiWave(wave: ApiWave): PublicWaveShellData {
  return {
    id: wave.id,
    name: wave.name,
    picture: wave.picture ?? null,
    descriptionPreview: getWaveDescriptionPreviewText(wave),
    membersCount: wave.metrics.subscribers_count,
    postsCount: wave.metrics.drops_count
  };
}
export function usePublicWaveShellState(waveId, t0) {
  const $ = _c(11);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  const shouldResolve = enabled && waveId !== null;
  let t3;
  if ($[2] !== shouldResolve) {
    t3 = {
      enabled: shouldResolve
    };
    $[2] = shouldResolve;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    wave,
    isError
  } = useWaveById(waveId, t3);
  if (!shouldResolve) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        status: "loading"
      };
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  if (wave?.id === waveId) {
    let t4;
    if ($[5] !== wave) {
      t4 = getPublicWaveShellDataFromApiWave(wave);
      $[5] = wave;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== t4) {
      t5 = {
        status: "ready",
        wave: t4
      };
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  if (isError) {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        status: "unavailable"
      };
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      status: "loading"
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}